export function GestureActionView({children}: {children: React.ReactNode}) {
  return children
}
